// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"593d4443","413":"19192161"}[chunkId] + ".chunk.js";
};